/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Connection, ConnectionType } from '../../../redux/slices/connectionsSlice';
import { PendingBadge, UnverifiedBadge, VerifiedBadge } from '../icons/ConnectionTypeBadge';

interface ConnectionStatusProps {
  connection: Connection;
  interactive?: boolean;
  className?: string;
}

export default function ConnectionStatus({
  connection,
  interactive = false,
  className = '',
}: ConnectionStatusProps): JSX.Element {
  if (connection.type === ConnectionType.MEMBER)
    return <VerifiedStatus className={className} />;
  if (connection.type === ConnectionType.EXTERNAL_MEMBER && connection.inviteSent)
    return <PendingStatus className={className} />;
  return (
    <UnverifiedStatus connection={connection} interactive={interactive} className={className} />
  );
}

interface StatusProps {
  className: string;
}

function VerifiedStatus({ className }: StatusProps) {
  return <VerifiedBadge className={className} />;
}

function PendingStatus({ className }: StatusProps) {
  return <PendingBadge className={className} />;
}

type UnverifiedStatusProps = StatusProps & {
  connection: Connection;
  interactive: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function UnverifiedStatus({ className, connection, interactive }: UnverifiedStatusProps) {
  return <UnverifiedBadge className={className} />;
}
